import React from "react";
import { Link } from "react-router-dom";
import "../style/css/RegistrationSuccess.css"; // Link to the new CSS file

// --- RegistrationSuccess Component ---
export function RegistrationSuccess() {
  return (
    // Reusing 'login-page-container' for centered layout, but using success-specific classes
    <div className="success-page-container">
      <div className="success-auth-container">
        {/* Header Icon and Title (Styled to match the form pages) */}
        <h2 className="text-center" style={{ marginBottom: "2rem" }}>
          <i
            className="fas fa-calendar-check"
            aria-hidden="true"
            style={{ color: "var(--color-accent)" }}
          ></i>{" "}
          Cara de agenda
        </h2>

        {/* Success Card */}
        <div className="success-card">
          <div className="success-icon">
            <i className="fas fa-check-circle" aria-hidden="true"></i>
          </div>

          <h3
            style={{
              textAlign: "center",
              color: "var(--success)",
              marginBottom: "var(--space-sm)",
            }}
          >
            ¡Registro Exitoso!
          </h3>

          <p
            className="text-center"
            style={{
              color: "var(--text-dark)",
              marginBottom: "var(--space-md)",
            }}
          >
            ¡Felicidades! Tu cuenta ha sido creada con éxito. Ya puedes iniciar
            sesión y comenzar a gestionar tu agenda.
          </p>

          <p
            className="text-center"
            style={{
              fontSize: "0.9rem",
              color: "var(--neutral-300)",
              marginBottom: "var(--space-lg)",
            }}
          >
            Te hemos enviado un correo electrónico de bienvenida con más
            detalles.
          </p>

          {/* Action Button */}
          <Link
            to="/login" // Link to your login route
            className="btn btn--primary btn--large"
            style={{ width: "100%", justifyContent: "center" }}
          >
            <i className="fas fa-sign-in-alt"></i>
            Ir a Iniciar Sesión
          </Link>
        </div>

        {/* Footer Text */}
        <p
          className="text-center"
          style={{
            marginTop: "var(--space-md)",
            fontSize: "0.9rem",
            color: "var(--color-secondary)",
          }}
        >
          Gracias por unirte a nuestra comunidad.
        </p>
      </div>
    </div>
  );
}

export default RegistrationSuccess;
